import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root: {

  },
  referentText: {
    fontSize: '14px',
    color: theme.palette.grey.grey500,
    marginBottom: '19px'
  },
  referentsWrapper: {
    marginTop: '25px'
  },
  referentInputWrapper: {
    marginBottom: '21px'
  },
  partTitle: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '14px',
    color: theme.palette.primary.primary500,
    fontWeight: 600,
    marginBottom: '12px',
    '& span': {
      marginLeft: '7px'
    }
  },
  referentList: {
    maxHeight: '100px',
    overflowY: 'auto',
  },
  referentListTitle: {
    fontSize: '14px',
    color: theme.palette.grey.grey500,
    fontWeight: 600,
    marginBottom: '14px'
  },
  referentListItem: {
    display: 'flex',
    alignItems: 'center',
  },
  referentItem: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '10px',
    width: '450px'
  },
  referentEmail: {
    marginLeft: '7px',
    marginRight: '7px',
    fontSize: '14px',
    fontWeight: 600,
    color: theme.palette.grey.grey700
  },
  deleteReferentButton: {
    color: theme.palette.error.error500,
    fontSize: '12px',
    textDecoration: 'underline',
    cursor: 'pointer',
    marginLeft: 'auto',
    '&:hover': {
      color: theme.palette.error.error600,
    },
    '&:active': {
      color: theme.palette.error.error400
    }
  },
  buttons: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    marginLeft: 'auto',
    marginTop: '25px'
  }
}));

export default useStyles;
